import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as styles from './styles.module.css';

/**
 * StatusBadge component for displaying report status
 * Reusable across card and table views
 * 
 * @param {Object} props
 * @param {number|string} props.status - Status value (0 = Draft, 1 = Published)
 * @returns {JSX.Element} Status badge element
 */
function StatusBadge({ status }) {
  const { t } = useTranslation();

  // Normalize status to number for comparison
  const normalizedStatus = parseInt(status, 10);

  // Determine status text and class
  const isPublished = normalizedStatus === 1;
  const statusText = isPublished 
    ? t('reports.status.published') 
    : t('reports.status.draft');
  
  const statusClass = isPublished ? styles.published : styles.draft;

  return (
    <span className={`${styles.badge} ${statusClass}`}>
      {statusText}
    </span>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default React.memo(StatusBadge);

